import { Component, Input } from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';
import { VgStates } from './videogular/VgStates';

import styles from './VbSubtitleDisplay.module.less';

@Component({
	selector: 'vb-subtitle-display',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<div
			[ngClass]="styles.subtitles"
			*ngIf="vgApi.isHtmlSubtitleRenderingEnabled &amp;&amp; vgApi.currentSubtitle &amp;&amp; isPlaying"
			[innerHTML]="vgApi.currentSubtitle">
		</div>`,
    standalone: false
})
export class VbSubtitleDisplayComponent {
	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) {}

	public get isPlaying(): boolean {
		return this.vgApi.currentState === VgStates.PLAY;
	}
}
